module.exports = __webpack_public_path__ + "img/2moblie.ee9aebec.png";